<template>
  <div class="sign-sale">
    <div class="sign-sale-header">
        <h3 style="font-weight:700;" v-if="!is_catalog_signs && clone_sign?.allClients!='false'">מבצע</h3>
        <h3 style="font-weight:700;" v-else>מבצע לחברי מועדון</h3>
        <h1 style="font-weight:500;" v-if="is_catalog_signs">רוסמן מרקט</h1>
        <div @click="handle_duplicate_sign(sign)" v-if="!is_catalog_signs" class="duplicate_btn no-see-in-print">
            <i class="material-icons duplicate_icon">control_point_duplicate</i>
        </div>
        <div v-if="!is_catalog_signs && sign.is_duplicate" @click="handle_remove_duplicate_sign(sign)" class="remove_duplicate_btn no-see-in-print">
            <i class="material-icons remove_duplicate_icon">delete</i>
        </div>
    </div>
    <div class="sign-sale-input-texts">
        <div class="he">
            <el-input :input-style="input_style" style="width:100%;" v-if="!is_sales_print" v-model="clone_sign.RemarkForPrint" maxlength="35" placeholder="שם המוצר בעברית" />
            <h1 :style="getDynamicStyles" v-if="is_sales_print">{{formattedName}}</h1>
        </div>
        <i v-if="is_catalog_signs"  @click="handle_show_items_list" class="material-icons float-icon add-icon">add</i>
    </div>
    <div v-if="!is_catalog_signs" class="sign-sale-contents">
        <el-input :input-style="input_style" type="number" v-if="!is_sales_print" v-model="clone_sign.amount" placeholder="כמות" />
        <el-input :input-style="input_style" type="number" v-if="!is_sales_print" v-model="clone_sign.sum_price" placeholder="מחיר" />
        <template v-if="is_sales_print">
            <h2 class="amount-line" style="font-weight:600;">
                <span v-if="Number(sign?.amount) > 0.01 && !sign?.Department?.includes('שקיל') && !sign?.Department?.includes('משקל')">{{clone_sign.amount}} יח'</span>
                <span v-else-if="Number(sign?.amount) < 1 || sign?.Department?.includes('שקיל') || sign?.Department?.includes('משקל')">{{clone_sign.amount}} גרם</span>
                ב  -
            </h2>
            <h1 class="price-line" style="font-weight:700;">{{clone_sign.sum_price}} <small>&#8362;</small></h1>
        </template>
    </div>
    <div v-else class="sign-sale-contents catalog">
        <div v-if="!is_sales_print" class="col-2 col">
            <el-input :input-style="input_style" type="number" v-model="clone_sign.price" placeholder="מחיר" />
        </div>
        <div v-if="!is_sales_print" class="col-1 col">
            <h1>ל-</h1>
        </div>
        <div v-if="!is_sales_print" class="col-2 col">
            <el-input :input-style="input_style"  v-model="clone_sign.unit" placeholder="הזן יחידת מידה" />
        </div>
        <h1 style="font-weight:500;" v-if="is_sales_print">
            {{clone_sign.price}} &#8362; <span>ל - {{clone_sign.unit}}</span>
        </h1>
    </div>
    <div v-if="clone_sign?.products?.length > 0" class="sign-sale-footer">
        <div class="col barcodes">
            <h1 style="font-weight:500;" data-fixed>
            ברקוד:
            </h1>
            <h1 style="font-weight:500;" data-slice v-if="clone_sign?.Items?.length > 0">
                {{clone_sign.products.slice(0, 6).map(product => product.barcode.slice(-5)).join(",") + (clone_sign.products.length > 6 ? '...' : '')}}
            </h1>
            <h1 style="font-weight:500;" data-slice v-if="clone_sign?.barcode">
                {{clone_sign?.barcode.slice(-5)}}
            </h1>
        </div>

        <div v-if="!is_catalog_signs" class="col price">
            <el-input
            v-if="!is_sales_print"
            style="font-size: 13px;"
            :input-style="{...input_style, 'font-size':'13px', 'color':'#333'}"
            v-model="clone_sign.original_price"
            placeholder="מחיר רגיל ליח' או ל100 גר'"
            />
            <small v-else>מחיר רגיל: {{clone_sign.original_price}} &#8362;</small>
        </div>
    </div>
    <div v-else class="sign-sale-footer item-error">
        <h1 style="font-size:12px; text-align:center;">
            פריט לא הוקם טוב בקומקס נא לפנות למחלקת סחר
        </h1>
    </div>
    <div v-if="!is_catalog_signs" class="prormo-limit" :class="limit_class">
        <p style="font-weight:500;">{{limit_text}}</p>
    </div>
    <div v-if="show_items_list" class="choos-item slide-in-top">
        <ItemsList @back="show_items_list=false; clone_sign={};" @item_choosen="handle_item_choosen" />
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import {is_sales_print} from '../Scripts/scripts'
import {is_catalog_signs} from './Deals/Scripts/store'
import { computed, defineAsyncComponent, onBeforeUnmount } from 'vue'
import {translate_hebrew_to_russian} from '../components/Deals/Scripts/script'
import {printer_amount,handle_duplicate_sign,handle_remove_duplicate_sign,is_deleted} from '../components/Deals/Scripts/store'
import {slide_pop_error} from '../../../../Methods/Msgs'
import ErrorTranslateSign from './Errors/ErrorTranslateSign.vue'
import { ElNotification } from 'element-plus'


export default {
    props:['sign'],
    components:{
        ItemsList:defineAsyncComponent(()=>import('../ItemsList.vue')),
        ErrorTranslateSign,
    },
    setup(props){

        const show_error = ref(false)
        const translate_action = ref(false)

        const dotsCount = ref(0);

        const loadingDots = computed(() => {
            const dots = ['.', '..', '...'];
            return dots[dotsCount.value % dots.length];
        });

        const interval = setInterval(() => {
            dotsCount.value++;
        }, 1000);

        const handle_translate_to_ru = async(hebrew) => {
            try{
                if(!hebrew){
                    throw new Error('עליך להזין שם המוצר בעברית תחילה!')
                }else{
                    clone_sign.value.ru_name = null
                    translate_action.value = true
                    clone_sign.value.ru_name = await translate_hebrew_to_russian(hebrew)
                }
            }catch(err){
                clone_sign.value.ru_name = null
                translate_action.value = false
                slide_pop_error(err.message)
            }
        }

        const handle_show_items_list = () => {
            show_items_list.value=true
            clone_sign.value.ru_name = null
            clone_sign.value.ru_name = null
            translate_action.value = false
        }


        const ru_loader = ref(false)
        const show_items_list = ref(false)

        const clone_sign = ref({})

        const limit_text = computed(() =>
            (clone_sign.value?.limitations || [])
                .filter(lim => lim && lim.trim() && lim != 'לחברי מועדון בלבד')
                .join(', ')
        )
        const limit_class = computed(() => {
            const len = limit_text.value.length
            if (len > 60) return 'pl-tier-4'
            if (len > 40) return 'pl-tier-3'
            if (len > 24) return 'pl-tier-2'
            return ''
        })

        const input_style = ref({
            'font-size':'16px',
            'color':'black',
            'margin-top':'5px',
            'text-align': 'center',
            'border': '2px solid black',
            'border-left':'0',
            'border-right':'0',
            'border-top':'0',
        })

        const handle_item_choosen = (item) => {
            show_items_list.value = false
            const isWeight = item.amount == '0.01'
                || item.Department?.includes('שקיל')
                || item.Department?.includes('משקל');
            clone_sign.value = {
                RemarkForPrint:item.Name,
                barcode:item.barcode,
                price:isWeight?(Number(item?.price)/10).toFixed(2):item?.price,
                amount:item.amount,
                unit:isWeight?'100 גרם':'יח\'',
                Department:item.Department
            }
        }

        const handle_translate_manuel = () => {
            clone_sign.value.ru_name=''
            show_error.value = false
            printer_amount.value.push(1)
        }

        const init = async() => {
            try{
                show_error.value = false
                if(props.sign){
                    clone_sign.value  = JSON.parse(JSON.stringify(props.sign))
                    clone_sign.value.original_price = clone_sign?.value?.products?.[0]?.price;
                    if(Number(props.sign.amount) < 1){
                        clone_sign.value.amount = 100
                        clone_sign.value.sum_price = (Number(clone_sign.value.sum_price) / 10).toFixed(2)
                        clone_sign.value.original_price = (Number(clone_sign.value.original_price) / 10).toFixed(2)
                    }
                    if(!is_catalog_signs.value && !props.sign.ru_name){
                        ru_loader.value = false
                        if(!is_deleted.value) printer_amount.value.push(1)
                        clone_sign.value.ru_name = props.sign.ru_name
                        ru_loader.value = true
                    }
                    else if(!is_catalog_signs.value && props.sign.ru_name && !is_deleted.value){
                        printer_amount.value.push(1)
                    }
                }
            }catch(err){
                console.log(err.message);
                ElNotification({
                    title: 'נא לשים לב',
                    message: `התרגום לפריט/למבצע ${clone_sign.value.RemarkForPrint} לא הצליח, נא לגלול לשלט לנסות שנית או לתרגם ידנית! `,
                    duration: 0,
                    type: 'warning',
                })
                show_error.value = true
            }
        }

        onBeforeUnmount(()=>{
            if(interval){
                clearInterval(interval);
            }
        })

        const getDynamicStyles = computed(() => {
            const text = clone_sign.value?.RemarkForPrint || '';
            const words = text.trim().split(/\s+/);
            const wordCount = words.length;

            let fontSize, lineHeight;

            if (wordCount <= 3) {
                fontSize = '22px';
                lineHeight = '1.2';
            } else {
                fontSize = '18px';
                lineHeight = '1.15';
            }

            return {
                fontWeight: 600,
                fontSize,
                lineHeight,
                margin: 0,
                padding: '2px',
                wordBreak: 'keep-all',
                whiteSpace: 'pre-line',
                overflow: 'hidden',
                maxHeight: '100%',
                textAlign: 'center',
                width: '100%',
            };
        });

        const formattedName = computed(() => {
            const text = clone_sign.value?.RemarkForPrint || '';
            const words = text.trim().split(/\s+/);
            if (words.length <= 3) {
                return text;
            }
            const firstLine = words.slice(0, 3).join(' ');
            const secondLine = words.slice(3).join(' ');
            return firstLine + '\n' + secondLine;
        });

        init()

        return{
            is_sales_print,
            input_style,
            clone_sign,
            is_catalog_signs,
            show_items_list,
            handle_item_choosen,
            ru_loader,
            loadingDots,
            translate_action,
            handle_translate_to_ru,
            handle_show_items_list,
            handle_translate_manuel,
            handle_duplicate_sign,
            handle_remove_duplicate_sign,
            show_error,
            init,
            getDynamicStyles,
            formattedName,
            limit_text,
            limit_class
        }
    }
}
</script>

<style scoped>
    h1, h2, h3 { margin: 0; font-size: inherit; }
    .sign-sale{
        position: relative;
        width: 100%;
        height: 100%;
        border: 0.3cm solid black;
        box-sizing: border-box;
    }
    .sign-sale::after {
            content: "";
            position: absolute;
            bottom: -0.3cm;
            left: 0;
            width: 100%;
            height: 0.3cm;
            border-bottom: 1px dashed #fff;
        }

        .sign-sale::before {
    content: "";
    position: absolute;
    top: 0;
    left: -0.3cm;
    width: 0;
    height: 100%;
    border-left: 1px dashed #fff;
    z-index: 1;
}
    .sign-sale-header{
        position: relative;
        width: 100%;
        height: 10%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
    }
    .duplicate_btn,.remove_duplicate_btn{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 3px;
        user-select: none;
    }
    .duplicate_icon,.remove_duplicate_icon{
        cursor: pointer;
        font-size: 18px;
    }
    .remove_duplicate_btn{
        right: 25px;
    }
    .remove_duplicate_icon{
        color: var(--danger);
    }
    .prormo-limit{
        height: 10%;
        width: 100%;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .logo{
        position: absolute;
        width: 60px;
        height: 100%;
        top: 0;
        left: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .logo img{
        max-width: 100%;
        max-height: 100%;
    }
    .sign-sale-input-texts{
        position: relative;
        width: 100%;
        height: 25%;
    }
    .add-icon,.clean-icon{
        color: var(--success);
        cursor: pointer;
        font-size: 35px;
        user-select: none;
    }
    .float-icon{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 3px;
    }
    .sign-sale-input-texts .he,.sign-sale-input-texts .ru{
        position: relative;
        width: 100%;
        height: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        text-align: center;
    }
    .sign-sale-input-texts .ru{
        font-size: 9px;
    }
    .add_translation{
        position: absolute;
        top: 50%;
        left: 30px;
        transform: translateY(-50%);
        width: 80px;
    }
    .float-icon,.save-icon,.add-deal-icon{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 30px;
    }
    .save-icon,.add-deal-icon{
        right: unset;
        left: 30px;
        color: var(--blue) !important;
    }
    .add-icon,.clean-icon,.save-icon,.add-deal-icon{
        color: var(--success);
        cursor: pointer;
        font-size: 28px;
        user-select: none;
    }
    .add-deal-icon::before{
        content: 'בחירת מבצע';
        font-size: 12px;
        position: absolute;
        bottom: 100%;
        left: -50%;
        font-family: 'Rubik', sans-serif;
    }
    .save-icon::before{
        content: 'שמירת מבצע';
        font-size: 12px;
        position: absolute;
        bottom: 100%;
        left: -50%;
        font-family: 'Rubik', sans-serif;
    }
    .clean-icon{
        color: var(--danger);
    }
    .clean-icon::before{
        content: 'נקה';
        font-size: 12px;
        position: absolute;
        bottom: 115%;
        right: 50%;
        transform: translateX(50%);
        font-family: 'Rubik', sans-serif;
    }
    .add-icon::before{
        content: 'בחירת פריט';
        font-size: 12px;
        position: absolute;
        bottom: 100%;
        right: 50%;
        transform: translateX(50%);
        font-family: 'Rubik', sans-serif;
    }
    .sign-sale-contents{
        width: 100%;
        height: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 20px;
    }
    .sign-sale-contents .amount-line{
        font-size: 16px;
    }
    .sign-sale-contents .price-line{
        font-size: 26px;
    }
    .sign-sale-contents.catalog{
        justify-content: center;
        align-items: center;
    }
    .col{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 3px;
        height: 100%;
    }
    .col-1{
        width: 10%;
        height: 100%;
    }
    .col-2{
        width: 45%;
        height: 100%;
    }
    .col.barcodes{
        width: 100%;
        flex-direction: row;
        flex-wrap: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 12px;
    }
    .col.small{
        font-size: unset;
        text-align: center;
        width: 30%;
        font-size: 14px;
    }
    .col.price{
        width: 100%;
        justify-content: center;
    }
    .col.price > small{
        font-weight: 500;
        font-size: 14px;
    }
    [data-slice]{
        white-space: nowrap;
        overflow-x: auto;
        text-overflow: unset;
    }
    [data-fixed]{
        display: flex;
        align-items: center;
    }
    .sign-sale-footer{
        width: 100%;
        height: 25%;
        display: flex;
        flex-direction: column;
        font-size: 13px;
        justify-content: space-between;
        padding: 1px 3px;
        overflow: hidden;
    }
    .sign-sale-footer.item-error{
        justify-content: center;
        align-items: center;
        color: red;
    }
    .choos-item,.choos-deal{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--main);
        z-index: 1000;
    }

    .slide-in-top {
	-webkit-animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	        animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }

    @-webkit-keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-1000px);
                transform: translateY(-1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
                transform: translateY(0);
        opacity: 1;
    }
    }
    @keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-1000px);
                transform: translateY(-1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
                transform: translateY(0);
        opacity: 1;
    }
    }
</style>
